import { useStaticQuery, graphql } from "gatsby"

export const useHomeBlogsQuery = () => {
    const { homeBlogWpPage, homeBlogAllWpPost } = useStaticQuery(
        graphql`
        query HomeBlogsQuery {
            homeBlogWpPage:wpPage(title: {eq: "Home"}) {
             homeBlog {
               homeBlogHeading
               homeBlogSubheading
             }
           }
           homeBlogAllWpPost:allWpPost(limit: 3, sort: {order: DESC, fields: date}) {
             nodes {
               featuredImage {
                 node {
                   localFile {
                     childImageSharp {
                       gatsbyImageData
                     }
                   }
                 }
               }
               featuredImageAltText{
                featuredImageAltText
              }
               title
               excerpt
               date(formatString: "MMM DD YYYY")
               link
             }
           }
         }
         
        `)
return {homeBlogWpPage, homeBlogAllWpPost}
}